import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Professionals who need to look sharp in a suit or dress 48 hours from now.', 'Anyone struggling with "emergency bloating" after a heavy weekend.', 'Men and women who want to feel light and clear-headed for a major event.', 'High-performers who value a practical, science-backed shortcut.'];
  const notForWho = ['People looking for a long-term weight loss solution (this is a tactical reset).', 'Those unwilling to follow a strict 48-hour schedule.', 'Anyone looking for a magic weight-loss pill.'];
  return <section className="py-24 bg-stone-50 border-y border-stone-200" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-3">
          {/* Who it's for */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-stone-100" data-id="element-4">
            <h3 className="text-2xl font-serif text-stone-900 mb-8 flex items-center" data-id="element-5">
              <span className="bg-forest-100 text-forest-800 px-3 py-1 rounded-full text-sm font-sans tracking-wide uppercase mr-4" data-id="element-6">
                Yes
              </span>
              Who This Is For
            </h3>
            <ul className="space-y-5" data-id="element-7">
              {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-8">
                  <CheckCircle2 className="w-6 h-6 text-forest-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-9" />
                  <span className="text-stone-700 leading-relaxed" data-id="element-10">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Who it's not for */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-stone-100" data-id="element-11">
            <h3 className="text-2xl font-serif text-stone-900 mb-8 flex items-center" data-id="element-12">
              <span className="bg-red-50 text-red-700 px-3 py-1 rounded-full text-sm font-sans tracking-wide uppercase mr-4" data-id="element-13">
                No
              </span>
              Who This Is NOT For
            </h3>
            <ul className="space-y-5" data-id="element-14">
              {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-15">
                  <XCircle className="w-6 h-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-16" />
                  <span className="text-stone-700 leading-relaxed" data-id="element-17">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}